import { store as AuthStore } from '@app/modules/Auth';
import { store as DashboardTabbedStore } from '@app/modules/Dashboard';
import { store as TagsStore } from '@app/modules/Layout';
import { store as ReportStore } from '@app/modules/Report';
import { store as RoomStore } from '@app/modules/Rooms';
import AnalyzeStore from '@app/modules/Analyze/store';
import ProfilesStore from '@app/modules/Profiles/Temperature/store';
import TenantsStore from '@app/modules/Tenants/store';
import CronProfilesStore from '@app/modules/Profiles/Schedule/store';

export class RootStore {
  authStore: AuthStore;
  tagsStore: TagsStore;
  dashboardStore: DashboardTabbedStore;
  analyzeStore: AnalyzeStore;
  profilesStore: ProfilesStore;
  cronProfilesStore: CronProfilesStore;
  tenantsStore: TenantsStore;
  reportStore: ReportStore;
  roomStore: RoomStore;

  constructor() {
    this.authStore = new AuthStore();
    this.dashboardStore = new DashboardTabbedStore();
    this.tagsStore = new TagsStore();
    this.analyzeStore = new AnalyzeStore();
    this.profilesStore = new ProfilesStore();
    this.cronProfilesStore = new CronProfilesStore();
    this.tenantsStore = new TenantsStore();
    this.reportStore = new ReportStore();
    this.roomStore = new RoomStore();
  }
}
